import { FunctionComponent, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';

import { Routes } from 'types/routes';

import Button from 'components/layout/Button';
import { ButtonStyles, ButtonVariants } from 'components/layout/Button/types';
import LayoutContainer from 'components/layout/LayoutContainer';
import Link from 'components/layout/Link';
import Logo from 'components/layout/Logo';

import StyledComponent from './styles';
import { Props } from './types';

const WrapperPublicBlocksTopbar: FunctionComponent<Props> = ({ className }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const router = useRouter();

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setIsScrolled(scrollTop > 50);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <StyledComponent className={classNames('wrapper-public-blocks-topbar-desktop', className, { 'scrolled': isScrolled })}>
            <LayoutContainer>
                <div className="columns">
                    <div className="column-brand">
                        <Link
                            className="logo-link"
                            href={Routes.PublicHome}
                        >
                            <Logo
                                width={240}
                                height={66}
                            />
                        </Link>
                    </div>
                    <nav className="column-nav">
                        <Link
                            className="nav-link"
                            href="#services"
                        >
                            Dlaczego POCHP?
                        </Link>
                        <Link
                            className="nav-link"
                            href="#details"
                        >
                            Możliwości
                        </Link>
                        <Link
                            className="nav-link"
                            href={Routes.PublicContactForm}
                        >
                            Kontakt
                        </Link>
                    </nav>
                    <div className="column-cta">
                        <Button
                            style={ButtonStyles.Secondary}
                            variant={ButtonVariants.Outline}
                            onClick={() => router.push(Routes.PublicCompanyRegistrationForm)}
                        >
                            Zarejestruj się
                        </Button>
                    </div>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default WrapperPublicBlocksTopbar;
